import React from "react";
import { Skeleton } from "components";
import { Col, Row } from "react-bootstrap";

export default function CardSkeleton({ count = 4, perRow = 4 }) {
  let col = {
    // When perRow = 3 4
    xl: 12 / perRow, // 4 3
    lg: 12 / (perRow - 1), // 6
    md: 12 / (perRow - (perRow % 2 === 0 ? 2 : 1)), // 6
    sm: 12 / (perRow - 2), // 6
    xs: 12, // 12
  };

  return (
    <Row>
      {Array(count)
        .fill((i) => i)
        .map((_, index) => (
          <Col
            key={index}
            xl={col.xl}
            lg={col.lg}
            md={col.md}
            sm={col.sm}
            xs={col.xs}
            className={`p-0
            ${
              perRow === count && index + 1 > 12 / col.xs
                ? "d-none d-sm-block"
                : ""
            }${" "}
            ${
              perRow === count && index + 1 > 12 / col.sm
                ? "d-sm-none d-md-block"
                : ""
            }${" "}
            ${
              perRow === count && index + 1 > 12 / col.md
                ? "d-md-none d-lg-block"
                : ""
            }${" "}
            ${
              perRow === count && index + 1 > 12 / col.lg
                ? "d-lg-none d-xl-block"
                : ""
            }${" "}
            `}
          >
            {/* about us card */}
            <div
              className={`mx-1 mb-2 author_card bg-white border border-light2 border-2 rounded-3 py-4`}
            >
              <Row>
                <Col xs={12} className="text-center">
                  <Skeleton count={1} height={200} width={200} />
                </Col>
                <Col xs={12} className="text-center mt-4 mt-4 mt-4 ">
                  <Skeleton count={1} height={10} width={"80%"} />
                </Col>
                <Col xs={12} className="text-center">
                  <Skeleton count={1} height={10} width={"80%"} />
                </Col>
                <Col xs={6} className="text-center mt-4 mt-4 mt-4 ">
                  <Skeleton count={1} height={10} width={"80%"} />
                </Col>
                <Col xs={6} className="text-center mt-4 mt-4 mt-4 ">
                  <Skeleton count={1} height={10} width={"80%"} />
                </Col>
              </Row>
            </div>
          </Col>
        ))}
    </Row>
  );
}
